import network from '@/services/network';

/**
 * "Was ist neu"-Anzeige (Fix 6, docs/tasks/feedback-fixes-2026-07-23.md).
 * Nur Lesen + Lesestand — Eintraege entstehen redaktionell via Artisan.
 */
export interface ChangelogEntry {
  id: number;
  title: string;
  body: string;
  published_at: string;
}

const getUnseen = async (): Promise<{ data: ChangelogEntry[] }> => {
  const { data } = await network.get<{ data: ChangelogEntry[] }>('/changelog/unseen');
  return data;
};

const markSeen = async (lastSeenId: number): Promise<void> => {
  await network.post('/changelog/seen', { last_seen_id: lastSeenId });
};

const getAll = async (): Promise<{ data: ChangelogEntry[] }> => {
  const { data } = await network.get<{ data: ChangelogEntry[] }>('/changelog');
  return data;
};

export default { getUnseen, markSeen, getAll };
